module.exports = __webpack_public_path__ + "img/integracao.ed033926.svg";